import { LISTING_TYPES } from "../Listing.constants";

/**
 * This function returns the unit value to be shown in price summary section
 * @param listingType The type of the listing
 * @returns string: unit value to be shown in price summary
 */
export const getUnitLabelForPriceSummary = (listingType: number) => {
    switch (listingType) {
        case LISTING_TYPES.WEBINAR:
        case LISTING_TYPES.APPOINTMENTS:
            return "Slot";
        case LISTING_TYPES.MERCHANDISE:
            return "Quantity";
        default:
            return "";
    }
};
